export const APP_TOAST_TYPES = ["success", "error", "warning", "info"];

export function resolveAppToastDuration(type, explicitDuration) {
  if (explicitDuration != null && Number.isFinite(Number(explicitDuration))) {
    return Math.max(0, Number(explicitDuration));
  }
  return type === "success" || type === "info" ? 3000 : 5000;
}

export function resolveAppToastPosition() {
  if (typeof window === "undefined") return "desktop-top-end";
  return window.matchMedia("(max-width: 640px)").matches
    ? "mobile-top-center"
    : "desktop-top-end";
}
